import React from 'react';
import './RankingSystem.css';

function RankingSystem({ gamesWon, isDarkMode }) {
  const ranks = [
    { level: "🐣 Movie Novice", score: 0 },
    { level: "🍿 Casual Viewer", score: 20 },
    { level: "🎬 Movie Buff", score: 40 },
    { level: "📽️ Film Enthusiast", score: 60 },
    { level: "🎥 Cinephile", score: 80 }
  ];

  ranks.sort((a, b) => b.score - a.score);
  const currentRank = ranks.find(rank => gamesWon >= rank.score);
  ranks.sort((a, b) => a.score - b.score);
  const nextRank = ranks.find(rank => gamesWon < rank.score);

  const progressToNext = nextRank ? ((gamesWon - currentRank.score) / (nextRank.score - currentRank.score)) * 100 : 100;
  const pointsToNextRank = nextRank ? nextRank.score - gamesWon : 0;

  return (
    <div className="ranking-system">
      <h3>Movie Rank Roadmap</h3>
      <div className="ranks-progress-container">
        {ranks.map((rank, index) => {
          const isReached = gamesWon >= rank.score;
          const isCurrent = rank.level === currentRank.level;
          return (
            <div
              key={index}
              className={`rank-row ${isReached ? 'reached' : ''} ${isCurrent ? 'current' : ''}`}
            >
              <span className="rank-label">{rank.level}</span>
              <span className="rank-score-req">{rank.score}%</span>
            </div>
          );
        })}
      </div>

      <div className="current-rank-showcase">
        <span className="rank-badge">{currentRank.level.split(' ')[0]}</span>
        <span className="rank-name">{currentRank.level.split(' ').slice(1).join(' ')}</span>

        <div className="progress-container">
          <div className="progress-filler" style={{ width: `${progressToNext}%` }}></div>
        </div>

        <span className="progress-text">
          {nextRank
            ? `${pointsToNextRank}% more wins to reach ${nextRank.level.split(' ').slice(1).join(' ')}`
            : "You've reached the top rank! 🎬"}
        </span>
      </div>
    </div>
  );
}

export default RankingSystem;
